import { render, staticRenderFns } from "./domuneoLogo.vue?vue&type=template&id=4756595c&scoped=true&"
import script from "./domuneoLogo.vue?vue&type=script&lang=js&"
export * from "./domuneoLogo.vue?vue&type=script&lang=js&"
import style0 from "./domuneoLogo.vue?vue&type=style&index=0&id=4756595c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4756595c",
  null
  
)

export default component.exports